import getClusterId from '@/common/store/pinia/storageCluster/getClusterId';

function resource() {
  return getClusterId()
    .then(clusterId => `/api/v2/${clusterId}/nfs/auth/ldap-settings`);
}

const getInitialState = () => ({
  config: {
    base_dn: null,
    bind_dn: null,
    domain: null,
    ldap_enabled: false,
    local_realms: null,
    uri: null
  }
});

export default {
  name: 'nfsLdapSettings',
  namespaced: true,
  state: getInitialState(),
  getters: {
    config: state => state.config,
  },
  mutations: {
    SET_CONFIG(state, config) {
      state.config = config;
    },
    FLUSH_STATE(state) {
      Object.assign(state, getInitialState());
    },
  },
  actions: {
    FETCH_CONFIG({ commit }) {
      return resource().then(url => this.$api.get(url)).then(({ data }) => {
        commit('SET_CONFIG', data);
      });
    },
    UPDATE({ commit }, payload) {
      return resource().then(url => this.$api.post(url, payload)).then(({ data }) => {
        commit('SET_CONFIG', data);
      });
    }
  }
};
